import { render, staticRenderFns } from "./BoardEquationDialog.vue?vue&type=template&id=a0ef14d6&scoped=true&"
import script from "./BoardEquationDialog.vue?vue&type=script&lang=js&"
export * from "./BoardEquationDialog.vue?vue&type=script&lang=js&"
import style0 from "./BoardEquationDialog.vue?vue&type=style&index=0&id=a0ef14d6&prod&lang=scss&scoped=true&"
import style1 from "./BoardEquationDialog.vue?vue&type=style&index=1&id=a0ef14d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ef14d6",
  null
  
)

export default component.exports